export default async function() {
	document.getElementById('printChart')?.addEventListener('click', e => {
		e.preventDefault();
		window.print();
	});
}
